import ipadIcon from '@/assets/device-icons/ipad.svg';

interface IpadIconProps {
  className?: string;
}

export const IpadIcon = ({ className = "h-5 w-5" }: IpadIconProps) => {
  return (
    <img 
      src={ipadIcon} 
      alt="iPad" 
      className={className}
    />
  );
};
